import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		moneybird: null,
		documentStyles: null,
		urlAuth: null,
	},
	getters: {
		moneybird(state) {
			return state.moneybird;
		},
		documentStyles(state) {
			return state.documentStyles;
		},
		authUrl(state) {
			return state.urlAuth;
		},
	},
	mutations: {
		SET_MONEYBIRD(state, moneybird) {
			state.moneybird = moneybird
		},
		SET_DOCUMENTSTYLES(state, documentStyles) {
			state.documentStyles = documentStyles
		},
		SET_AUTHURL(state, authUrl) {
			state.urlAuth = authUrl
		},
		CLEAR_STORE(state) {
			state.moneybird = null;
			state.documentStyles = null;
			state.urlAuth = null;
		}
	},
	actions: {
		init({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('settings/accounting/moneybird/get').then(res => {
					commit('SET_MONEYBIRD', res.data);
					resolve();
				}).catch(err => {
					reject();
				})
			});
		},
		createMoneybird({commit}, credentials) {
			const params = {
				client_id: credentials.client_id,
				client_secret: credentials.client_secret,
			};

			return new Promise((resolve, reject) => {
				apiClient.post('settings/accounting/moneybird/create', params).then(res => {
					commit('SET_MONEYBIRD', res.data);
					resolve()
				}).catch(err => {
					reject()
				})
			});
		},
		validateMoneybird({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('settings/accounting/moneybird/validate').then(res => {
					commit('SET_MONEYBIRD', res.data);
					resolve()
				}).catch(err => {
					reject()
				})
			})
		},
		documentsStylesMoneybird({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('settings/accounting/moneybird/documentstyles').then(res => {
					commit('SET_DOCUMENTSTYLES', res.data);
					resolve()
				}).catch(err => {
					reject()
				})
			});
		},
		authUrlMoneybird({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('settings/accounting/moneybird/authurl').then(res => {
					commit('SET_AUTHURL', res.data);
					resolve()
				}).catch(err => {
					reject()
				})
			})
		},
		updateMoneybird({commit}, params) {
			return new Promise((resolve, reject) => {
				apiClient.put('settings/accounting/moneybird/update', params).then(res => {
					commit('SET_MONEYBIRD', res.data);
					resolve()
				}).catch(err => {
					reject()
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
